import { type EditorProps } from "@tiptap/pm/view";
import { cx } from "shared/utils";

interface TArgs {
  editorClassName: string;
}

export const CoreEditorProps = (props: TArgs): EditorProps => {
  const { editorClassName } = props;

  return {
    attributes: {
      class: cx("max-w-full", editorClassName)
    },
    handleDOMEvents: {
      keydown: (_view, event) => {
        // prevent default event listeners from firing when slash command is active
        if (["ArrowUp", "ArrowDown", "Enter"].includes(event.key)) {
          const slashCommand = document.querySelector("#slash-command");
          if (slashCommand) return true;
        }
      }
    },
    transformPastedHTML(html) {
      return html.replace(/<img.*?>/g, "");
    }
  };
};
